import { OTPCheckDto } from '../../../dto/otp/otpcheck/otpcheckdto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface OTPCheckRequest extends APIRequest
{
    getOTPCheckRequest(): OTPCheckDto;
}

export class OTPCheckRequestImpl extends APIRequestDtoImpl implements OTPCheckRequest
{
    constructor(private OTPCheckData: OTPCheckDto)
    {
        super();
    }

    getOTPCheckRequest(): OTPCheckDto
    {
        return this.OTPCheckData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/otp/otpcheck/otpcheckrequest.tsx